import { defineStore } from 'pinia';
import { ref } from 'vue';

// View preferences never enter the annotation snapshot or dirty/lease checks.
export const useDentalSceneStore = defineStore('dental-scene', () => {
  const enabled = ref(false);
  const segmentationVisible = ref(true); const selectedOnly = ref(false);
  const segmentationOpacity = ref(0.72); const volumeVisible = ref(true);
  const landmarksVisible = ref(true); const landmarkLabels = ref(true); const landmarkRadius = ref(0.65);
  const meshVisible = ref(true); const meshOpacity = ref(0.9);
  const originalVisible = ref(false); const residualsVisible = ref(true);
  const surfaceBusy = ref(false); const surfaceCount = ref(0); const surfaceBuildMs = ref(0); const surfaceError = ref('');
  return { enabled, segmentationVisible, selectedOnly, segmentationOpacity, volumeVisible,
    landmarksVisible, landmarkLabels, landmarkRadius, meshVisible, meshOpacity,
    originalVisible, residualsVisible, surfaceBusy, surfaceCount, surfaceBuildMs, surfaceError };
});
